import type { ReactNode } from "react";
import U2000RequireRole from "../u2000Core/components/controls/U2000RequireRole";
import U3101, { U3101ROLES } from "./U3101";
import U3101EmployeeList from "./components/U3101EmployeeList";
import U3101EmployeeForm from "./components/U3101EmployeeForm";

interface RouteObject {
  path?: string;
  index?: boolean;
  element?: ReactNode;
  children?: RouteObject[];
}

const U3101Routes: RouteObject[] = [
  {
    path: "U3101",
    element: <U2000RequireRole allowedRoles={[U3101ROLES.READ]} />,
    children: [
      {
        path: "",
        element: <U3101 />,
        children: [
          { index: true, element: <U3101EmployeeList /> },
          { path: ":id", element: <U3101EmployeeForm /> },
        ],
      },
    ],
  },
];

export default U3101Routes;
